import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useContext, useEffect, useState } from "react";
import { contestationPeriodsService } from "../../services/ContestationPeriodsService";
import { formatDate } from "../../config/Config";
import { AppDB } from "../../App";
import ScreenLoader from "../../componets/ScreenLoader";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { politicalpartyusersService } from "../../services/PoliticalPartyUsersService";
import PoliticalPartyService from "../../services/PoliticalPartyService";


Date.prototype.toIsoString = function () {
    var tzo = -this.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function (num) {
            var norm = Math.floor(Math.abs(num));
            return (norm < 10 ? '0' : '') + norm;
        };
    return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60);
}




function calculateEndDate(startDate, years) {
    const date = new Date(startDate); // Convert input to Date object
    date.setFullYear(date.getFullYear() + parseInt(years)); // Add years
    return date;
}


export default function () {
    var { permission, toast } = useContext(AppDB);
    var { selectedParty, contestationPeriodID, setContestationPeriodID, setSelectedParty, setContestationPeriod } = useContext(PoliticalPartyDBContext);

    var politicalPartyService = new PoliticalPartyService()
    var raw_form = {
        "termYears": "",
        "startDate": "",
        "endDate": "",
        isEdit: false,
        show: false
    }
    var [form, setForm] = useState(raw_form)
    var [refresh, setRefresh] = useState(false)
    var [loading, setLoading] = useState(false)
    var [errors, setErrors] = useState({})
    var [tableData, setTableData] = useState([])

    function on_input(e, extra = {},removeItem) {
        var { value, name } = e.target

            setForm({ ...form, [name]: value,...extra })
        try {
            delete errors[removeItem];
        } catch (error) {
            
        }
        if (`${name}`.trim().length === 0) {
            setErrors({ ...errors, [name]: "required" })
        } else {
            delete errors[name];
            setErrors({ ...errors })
        }
    }

    useEffect(() => {
        setLoading(true)
        if (selectedParty?.politicalPartyID) {
            politicalPartyService.getExecutiveTerms(selectedParty?.politicalPartyID).then(res => {
                setTableData(res)
                setLoading(false)
            })
        }

    }, [refresh, selectedParty])

    function onSubmit() {
        var err = false
        for (const [key, value] of Object.entries(form)) {
            if (typeof value === 'string' && value.trim() === '') {
                errors[key] = "required";
                err = true;
            }
        }
        if (err) {
            return setErrors({ ...errors })
        } else {
            setErrors({})
        }


        function responseHandler(res) {
            setLoading(false)
            if (res.success) {
                setRefresh(!refresh)
                setForm(raw_form)
                setErrors({})
                toast.show({
                    severity: "success",
                    detail: `Executive term ${form.isEdit ? "updated" : "created"}`,
                    life: 2500
                });
            } else {

                toast.show({
                    severity: "error",
                    detail: res.message,
                    life: 2500
                })
            }
        }

        setLoading(true)
        var clone = { ...form,politicalPartyID:selectedParty.politicalPartyID }
        clone.startDate=clone.startDate?.toIsoString()
        clone.endDate=clone.endDate?.toIsoString()
        clone.registrationYear = clone?.registrationYear?.getFullYear()
        if (form.isEdit) {
            politicalPartyService.updateExecutiveTerms(clone).then(res => {
                responseHandler(res)
            })
        } else {
            politicalPartyService.createExecutiveTerms(clone).then(res => {
                responseHandler(res)

            })
        }
    }

    return (<>
        <ScreenLoader visible={loading} />
        <Dialog
            style={{ width: "100%", maxWidth: "600px" }}
            header={<h4>{form.isEdit ? "Update" : "Create"} Executive Term</h4>} onHide={() => {
                setForm(raw_form)
                setErrors({})
            }} visible={form.show}
            footer={<>
                <Button className="mr-2" label="Submit" onClick={onSubmit} />

                <Button className="p-button-danger" label="Close" onClick={() => {
                    setForm(raw_form)
                    setErrors({})
                }} />
            </>}
        >
            <br />
            <div className="grid">
                <div className="col-12">
                    <label >Term Years<span style={{ color: "red" }}>*</span></label>
                    <InputText className="w-full" max={2} maxLength={2} onChange={(e => on_input(e, {
                        "startDate": "",
                        "endDate": "",
                    }))} autoComplete="off" name={"termYears"} p value={Math.abs(parseInt(form.termYears)) || 0} />
                    <small style={{ width: "100%" }} className="p-error">
                        {errors?.termYears}
                    </small>
                </div>

                {![""].includes(form.termYears) && (<>
                    <div className="col-12">
                        <label >Start Date<span style={{ color: "red" }}>*</span></label>
                        <Calendar showIcon dateFormat="dd/mm/yy" value={form.startDate} onChange={(e => on_input(e, { endDate: calculateEndDate(new Date(e.value), form.termYears) },"endDate"))} name="startDate" className="w-full" />
                        <small style={{ width: "100%" }} className="p-error">
                            {errors?.startDate}
                        </small>
                    </div>
                    <div className="col-12">
                        <label >End Date<span style={{ color: "red" }}>*</span></label>
                        <Calendar showIcon dateFormat="dd/mm/yy" value={form.endDate} name="endDate" className="w-full" />
                        <small style={{ width: "100%" }} className="p-error">
                            {errors?.endDate}
                        </small>
                    </div>
                </>)}

            </div>
        </Dialog>
        <div className="card">
            <DataTable header={<>  <div className="flex justify-content-between align-items-center ">
                <h5>Executive Term</h5>
                <Button onClick={() => { setForm({ ...raw_form, show: true }) }} label="Create" />
            </div>


            </>} value={tableData}>
                <Column field="termYears" header={"Term Years"} />
                <Column header={"Start Date"} body={e => formatDate(e.startDate)} />
                <Column header={"End Date"} body={e => formatDate(e.endDate)} />

                <Column header={"Action"} field="Action" body={(row) => <Button
                    style={{
                        textAlign: "center",
                        width: "30px",
                        height: "30px",
                    }}
                    icon={"pi pi-pencil"}
                    className=" p-button-rounded"
                    onClick={() => {
                        setForm({
                            ...raw_form, show: true, isEdit: true, ...row,
                            startDate: new Date(row.startDate),
                            endDate: new Date(row.endDate),
                        })
                        setErrors({})
                    }}
                />}></Column>
            </DataTable>
        </div>
    </>)
}